
import { Component, Vue } from 'vue-property-decorator';
import {AccountDocument} from "@/interfaces/account.interfaces";

@Component
export default class SAccHomePage extends Vue {
  // Les props
  // Les propriétés
  // Les propriétés calculées
  private get theme() {
    return this.$store.state.theme
  }

  private get account(): AccountDocument | null {
    return this.$store.state.accountData
  }

  // Les hooks
  public mounted() {
    this.$store.commit('setWorkspace', 'Overview')
  }
  // Les méthodes surveillées
  // Les méthodes d'instance
  // Les méthodes statiques
}
